const svg = document.querySelector(".france-map__wrapper svg");
const regions = document.querySelectorAll(".france-map path");
const sidebar = document.getElementById("map-sidebar");
const sidebarContent = document.getElementById("sidebar-content");
const sidebarClose = document.getElementById("map-sidebar-close");
const backdrop = document.getElementById("map-sidebar-backdrop");

// Load global configuration
const configScript = document.getElementById("france-map-config");
let config = { enableActiveShadow: true };
if (configScript) {
  try {
    config = JSON.parse(configScript.textContent);
  } catch (e) {
    console.warn("Erreur de parsing de la configuration", e);
  }
}

const dataMap = {};
document.querySelectorAll(".region-collection-data").forEach(script => {
  const region = script.dataset.region;
  try {
    dataMap[region] = JSON.parse(script.textContent);
  } catch (e) {
    console.warn(`Erreur de parsing pour la région ${region}`, e);
  }
});

const isMobile = () => window.innerWidth <= 768;

regions.forEach(region => {
  const regionId = region.getAttribute("id");

  const data = dataMap[regionId];
  if (!data) return;

  // Handle display_region setting
  if (data.displayRegion === false) {
    region.classList.add("clickable-region--hidden");
    return;
  }

  // Accessibility: keyboard navigation + aria
  region.setAttribute("tabindex", "0");
  region.setAttribute("role", "button");
  region.setAttribute("aria-label", data.regionName || data.title || regionId);

  if (data.color) {
    region.style.fill = data.color;
  }

  if (data.strokeColor) {
    region.style.stroke = data.strokeColor;
  }

  if (data.strokeWidth !== undefined && data.strokeWidth !== null) {
    region.style.strokeWidth = data.strokeWidth + 'px';
  }

  // Store colors for different states
  const originalColor = data.color;
  const hoverColor = data.hoverColor || '#ffffffe7';
  const activeColor = data.activeColor || '#4ea54f';

  // Add hover effects
  region.addEventListener("mouseenter", () => {
    if (!region.classList.contains("region--active")) {
      region.style.fill = hoverColor;
      region.style.opacity = '0.85';
    }
  });

  region.addEventListener("mouseleave", () => {
    if (!region.classList.contains("region--active")) {
      region.style.fill = originalColor;
      region.style.opacity = '1';
    }
  });

  function activateRegion(e) {
    e.preventDefault();
    e.stopPropagation();

    // Si la sidebar est déjà ouverte, récupérer la position depuis le style actuel
    let scrollY;
    if (sidebar.classList.contains("map-sidebar--active")) {
      const currentTop = document.body.style.top;
      scrollY = currentTop ? parseInt(currentTop) * -1 : 0;
    } else {
      scrollY = window.scrollY;
    }

    // Appliquer la position de scroll comme style inline avant de bloquer le scroll
    document.body.style.top = `-${scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';

    const titleEl = document.createElement("h2");
    titleEl.textContent = data.title;
    let html = titleEl.outerHTML;

    const regionHtml = document.getElementById(`departments-${regionId}`);
    if (regionHtml) {
      html += regionHtml.innerHTML;
    }

    sidebarContent.innerHTML = html;

    // Only move the map if the sidebar is not already open
    const sidebarWasActive = sidebar.classList.contains("map-sidebar--active");
    sidebar.classList.add("map-sidebar--active");
    sidebar.setAttribute("aria-hidden", "false");
    backdrop.classList.add("map-sidebar__backdrop--active");
    document.body.classList.add("body--noscroll");

    if (!sidebarWasActive && !isMobile()) {
      // Calculate transform to position map 5em from left edge
      const svgRect = svg.getBoundingClientRect();
      const svgCurrentLeft = svgRect.left;
      const emSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const targetLeft = 5 * emSize;
      const translateAmount = targetLeft - svgCurrentLeft;
      svg.style.transform = `translateX(${translateAmount}px)`;
    }

    // Move focus to the close button for accessibility
    sidebarClose.focus();

    // Remove active class from all regions and restore their colors
    regions.forEach(r => {
      const rId = r.getAttribute("id");
      const rData = dataMap[rId];
      if (rData) {
        r.style.fill = rData.color;
        r.style.opacity = '1';
        r.style.filter = 'none';
      }
      r.classList.remove("region--active");
    });

    // Set clicked region as active and apply active color
    region.classList.add("region--active");
    region.style.fill = activeColor;
    region.style.opacity = '1';
    if (config.enableActiveShadow) {
      region.style.filter = 'drop-shadow(0 0 6px rgba(0,0,0,0.3))';
    }
  }

  region.addEventListener("click", activateRegion);

  // Keyboard support: Enter and Space
  region.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      activateRegion(e);
    }
  });
});

function quitRegionFocus(e) {
  if (e) e.preventDefault();

  // Récupérer la position de scroll sauvegardée
  const scrollY = document.body.style.top;

  // Restore original colors for all regions
  regions.forEach(r => {
    const regionId = r.getAttribute("id");
    const data = dataMap[regionId];
    if (data) {
      r.style.fill = data.color;
      r.style.opacity = '1';
      r.style.filter = 'none';
    }
    r.classList.remove("region--active");
  });

  sidebar.classList.remove("map-sidebar--active");
  sidebar.setAttribute("aria-hidden", "true");
  backdrop.classList.remove("map-sidebar__backdrop--active");
  document.body.classList.remove("body--noscroll");

  // Retirer les styles de position fixed
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';

  // Restaurer la position de scroll
  window.scrollTo(0, parseInt(scrollY || '0') * -1);

  svg.style.transform = '';
}

sidebarClose.addEventListener("click", (e) => {
  quitRegionFocus(e);
});

// Close sidebar when clicking backdrop
backdrop.addEventListener("click", (e) => {
  quitRegionFocus(e);
});

// Close sidebar with Escape key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && sidebar.classList.contains("map-sidebar--active")) {
    quitRegionFocus(e);
  }
});

// Basic focus trap within the sidebar
sidebar.addEventListener("keydown", (e) => {
  if (e.key !== "Tab" || !sidebar.classList.contains("map-sidebar--active")) return;

  const focusable = sidebar.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
});
